if (typeof window.customIncenseObserver === "undefined") {
  const customIncenseProductIds = [
    '10081798848813',
    '10081797734701',
    '10081798291757',
    '10081796391213',
  ];
 
  function hideCustomIncenseUI(form) {
    const idInput = form.querySelector('input[name="product-id"]');
    if (!idInput) return;
 
    const productId = idInput.value.trim();
    if (customIncenseProductIds.includes(productId)) {
      const parentContainer = form.closest(".product-item, .product-related-item");
      if (parentContainer) {
        const wishlistWrapper = parentContainer.querySelector(".wishlist-wrapper");
        if (wishlistWrapper) wishlistWrapper.style.display = "none";
 
        const quickAdd = parentContainer.querySelector(".quick-add-to-cart");
        if (quickAdd) quickAdd.style.display = "none";
      }
 
      form.querySelectorAll("button").forEach(btn => {
        btn.style.display = "none";
        btn.disabled = true;
      });
    }
  }
 
  // Run once on load
  document.querySelectorAll(".shopify-product-form").forEach(hideCustomIncenseUI);
 
  // Setup observer only once
  window.customIncenseObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (node.matches?.(".shopify-product-form")) {
            hideCustomIncenseUI(node);
          }
          node.querySelectorAll?.(".shopify-product-form").forEach(hideCustomIncenseUI);
        }
      });
    });
  });
 
  window.customIncenseObserver.observe(document.body, { childList: true, subtree: true });
}